export const pricePackageSchema = {
    name: '{type:"input", rules:"required"}',
    default: '{type:"switch"}',
}